import { render, staticRenderFns } from "./ElPromo.vue?vue&type=template&id=46d170b0"
import script from "./ElPromo.vue?vue&type=script&lang=js"
export * from "./ElPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports